<template>
  <div style="display: flex; justify-content: center; align-items: center;">
    <div style="position: absolute; bottom: 0;">
      <ExpedientePopUpAction ref="NotificarAction" cardTitle="Notificar movimiento" :cardDetail="this.item.description"
        type="notification" :clubId="this.item.club" :movimiento="this.item.id"></ExpedientePopUpAction>
      <ExpedientePopUpAction ref="MovimientoDetailAction" cardTitle="Detalle" :cardDetail="this.item.description"
        type="detail" :movimiento="this.item"></ExpedientePopUpAction>
    </div>
    <v-btn icon flat small @click="notificar" v-if='item.estadoExpediente && item.authorIsSaf'>
      <v-tooltip bottom>
        <v-icon slot="activator" size="20" :color="item.notified ? 'primary' : '#EF5350'">
          {{ item.notified ? 'fa-bell' : 'fa-bell-slash' }}
        </v-icon>
        <span>{{ item.notified ? 'Notificar nuevamente' : 'Pendiente de notificar' }}</span>
      </v-tooltip>
    </v-btn>
    <v-btn icon flat small @click="goExpediente">
      <v-tooltip bottom>
        <v-icon slot="activator" color="primary">keyboard_arrow_right</v-icon>
        <span>Ver movimiento</span>
      </v-tooltip>
    </v-btn>
  </div>
</template>

<script>
import ExpedientePopUpAction from './ExpedientePopUpAction.vue'
export default {
  props: {
    item: Object
  },
  components: {
    ExpedientePopUpAction
  },
  methods: {
    goExpediente () {
      this.$refs.MovimientoDetailAction.showDialog()
    },
    notificar () {
      this.$refs.NotificarAction.showDialog()
    }
  },
  created () {
  }
}
</script>
